module.exports = __webpack_public_path__ + "img/thermometer_primary.779bd783.svg";